import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, input, signal } from '@angular/core';
import { ActionSheetController, IonicModule, PopoverController } from '@ionic/angular';
import { FilePopoverComponent } from '../file-popover/file-popover.component';

@Component({
    selector: 'app-file-item',
    templateUrl: './file-item.component.html',
    styleUrls: ['./file-item.component.scss'],
    imports: [IonicModule, CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileItemComponent  implements OnInit {

  readonly fileName = input<string>(undefined);
  readonly fileDate = input<string>(undefined);
  readonly canShare = input<boolean>(undefined);
  @Output() fileClick = new EventEmitter<any>();
  @Output() share = new EventEmitter<any>();
  @Output() download = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  
  constructor(private popoverController: PopoverController) { }

  ngOnInit() {}

  onFileClick() {
    this.fileClick.emit();
  }

  openMenu(event: any) {
    event.stopPropagation();
    this.presentPopover(event);
  }

  async presentPopover(event) {
    const popover = await this.popoverController.create({
      component: FilePopoverComponent,
      componentProps: {
        canShare: signal(this.canShare())
      },
      event
    });

    await popover.present();

    await popover.onDidDismiss().then((data) => {
      if (data.data === "delete") {
        this.delete.emit();
      } 
      else if (data.data === "share") {
        this.share.emit();
      }
      else if (data.data === "download") {
        this.download.emit();
      }
    });
  }

}
